import { AnalysisSettings, LoadSettings, MaterialSettingsPair, ProfileDefaults } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getDefaultLoadSettings(): Promise<LoadSettings> {
  return DesignService.get('defaults/loadSettings');
}

export function getDefaultAnalysisSettings(): Promise<AnalysisSettings> {
  return DesignService.get('defaults/analysisSettings');
}

export function getDefaultMaterialSettings(): Promise<MaterialSettingsPair> {
  return DesignService.get('defaults/materialSettings');
}

export function getDefaultProfileDefaults(): Promise<ProfileDefaults> {
  return DesignService.get('defaults/profileDefaults');
}
